/**
 * The minimal footer (Essenziale): where the user is ("2 di 5 · Treno"), "AI assistant" (AI Act
 * art. 50, always visible), and at the right accessibility and start over.
 */
import { useApp } from '../../react/app';
import { useConnection, useMode, useScreen, useTranslate } from '../../react/hooks';
import { useUiActions } from '../../shell/useUiActions';
import { Icon } from '../../ui-kit/Icon';
import css from '../progress/Minimal.module.css';

export function MinimalFooter() {
  const app = useApp();
  const t = useTranslate();
  const screen = useScreen();
  const mode = useMode();
  const connection = useConnection();
  const actions = useUiActions();
  const steps = app.pack.steps;
  const index = steps.findIndex((s) => s.id === screen.def?.step);
  const where = index >= 0 ? t('status.step_of', { n: index + 1, total: steps.length, name: t(steps[index]!.label) }) : '';

  return (
    <footer className={css.footer}>
      <span className={css.where}>{where}</span>
      <span className={css.ai}><Icon name="assistant" size={20} />{t('ai.badge')}</span>
      <span className={css.spacer} />
      <span className={`${css.dot} ${css[connection.status] ?? ''}`} title={t(`status.${connection.status}`)} />
      <button className={`${css.icon} ${mode.id !== 'none' ? css.on : ''}`} onClick={() => actions.toggleModePicker()} aria-label={t('mode.title')}>
        <Icon name="accessibility" size={30} />
      </button>
      <button className={css.icon} onClick={() => actions.restart()} aria-label={t('action.restart')}>
        <Icon name="restart" size={30} />
      </button>
    </footer>
  );
}
